import Vue from 'vue'
import Router from 'vue-router'
import $request from "@/service.js"
import * as filters from '@/tools.js';
import {
  Dialog
} from 'vant'
import store from '../store/index'
//按需加载路由
const test = r => require.ensure([], () => r(require('@/pages/store/test')))
const storeLists = r => require.ensure([], () => r(require('@/pages/store/index')))
const storeDetail = r => require.ensure([], () => r(require('@/pages/store/storeDetail')))
const login = r => require.ensure([], () => r(require('@/pages/login')))
const register = r => require.ensure([], () => r(require('@/pages/register/index')))
const index = r => require.ensure([], () => r(require('@/pages/index/index')))
const policyPop = r => require.ensure([], () => r(require('@/pages/register/privacyPolicy')))
const selectArea = r => require.ensure([], () => r(require('@/pages/selectArea')))
const registerSupplyInfo = r => require.ensure([], () => r(require('@/pages/register/registerSupplyInfo')))
// 地址模块
const addressIndex = r => require.ensure([], () => r(require('@/pages/address/index')))
const changeAddress = r => require.ensure([], () => r(require('@/pages/address/changeAddress')))
const editAddr = r => require.ensure([], () => r(require('@/pages/address/editAddr')))
const map = r => require.ensure([], () => r(require('@/pages/address/map')))
//购物车
const cartIndex = r => require.ensure([], () => r(require('@/pages/cart/index')))
// 订单模块
const orderIndex = r => require.ensure([], () => r(require('@/pages/order/index')))
const orderDetail = r => require.ensure([], () => r(require('@/pages/order/orderDetail')))
const cancelOrder = r => require.ensure([], () => r(require('@/pages/order/cancelOrder')))
const orderRefund = r => require.ensure([], () => r(require('@/pages/order/orderRefund')))
const refundDetail = r => require.ensure([], () => r(require('@/pages/order/refundDetail')))
const account = r => require.ensure([], () => r(require('@/pages/order/account')))
const orderSuccess = r => require.ensure([], () => r(require('@/pages/order/orderSuccess')))
const orderFail = r => require.ensure([], () => r(require('@/pages/order/orderFail')))
const orderStatus = r => require.ensure([], () => r(require('@/pages/order/orderStatus')))
const payWaysList = r => require.ensure([], () => r(require('@/pages/order/payWaysList')))
const pcPay = r => require.ensure([], () => r(require('@/pages/order/pcPay')))
// 用户中心
const usercenterIndex = r => require.ensure([], () => r(require('@/pages/userCenter/index')))
const userInfoDetail = r => require.ensure([], () => r(require('@/pages/userCenter/userInfoDetail')))
const userCoupons = r => require.ensure([], () => r(require('@/pages/userCenter/userCoupons')))
const invalidCoupons = r => require.ensure([], () => r(require('@/pages/userCenter/invalidCoupons')))
const resetPassword = r => require.ensure([], () => r(require('@/pages/userCenter/resetPassword')))
const cardManage = r => require.ensure([], () => r(require('@/pages/userCenter/cardManage')))
const addCardSuccess = r => require.ensure([], () => r(require('@/pages/userCenter/addCardSuccess')))
const serviceGuide = r => require.ensure([], () => r(require('@/pages/userCenter/serviceGuide')))
const set = r => require.ensure([], () => r(require('@/pages/userCenter/set')))
const emailEdit = r => require.ensure([], () => r(require('@/pages/userCenter/emailEdit')))
const emailEditSuccess = r => require.ensure([], () => r(require('@/pages/userCenter/emailEditSuccess')))
const emailValue = r => require.ensure([], () => r(require('@/pages/userCenter/emailValue')))
const vipCard = r => require.ensure([], () => r(require('@/pages/userCenter/vipCard')))
const bindingCard = r => require.ensure([], () => r(require('@/pages/userCenter/bindingCard')))
const consumeRecord = r => require.ensure([], () => r(require('@/pages/userCenter/consumeRecord')))
const logout = r => require.ensure([], () => r(require('@/pages/userCenter/logout')))
const sharePageDetail = r => require.ensure([], () => r(require('@/pages/userCenter/sharePageDetail')))

//商品模块
const productList = r => require.ensure([], () => r(require('@/pages/shop/index')))
const goodsDetail = r => require.ensure([], () => r(require('@/pages/shop/goodsDetail')))
const searchGoods = r => require.ensure([], () => r(require('@/pages/shop/searchGoods')))
//专栏
const specialColumn1 = r => require.ensure([], () => r(require('@/pages/specialColumn/specialColumn1')))
const specialColumn2 = r => require.ensure([], () => r(require('@/pages/specialColumn/specialColumn2')))
const specialColumn3 = r => require.ensure([], () => r(require('@/pages/specialColumn/specialColumn3')))

Vue.use(Router)

const router = new Router({
  mode: 'history',
  // history: createWebHistory(),
  routes: [{
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: 'SungivenPLUS',
        type: 'login',
        keepAlive: false,
      }
    }, {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '登錄',
        type: ''
      }
    },
    {
      path: '/selectArea',
      name: 'selectArea',
      component: selectArea,
      meta: {
        title: '選擇國家/地區',
        type: ''
      }
    },
    {
      path: '/storeLists',
      name: 'storeLists',
      component: storeLists,
      meta: {
        title: 'SungivenPLUS',
        type: 'login'
      }
    },
    {
      path: '/storeDetail',
      name: 'storeDetail',
      component: storeDetail,
      meta: {
        title: '門店详情',
        type: 'login'
      }
    },
    {
      path: '/addressIndex',
      name: 'addressIndex',
      component: addressIndex,
      meta: {
        title: '地址列表',
        type: ''
      }
    },
    {
      path: '/changeAddress',
      name: 'changeAddress',
      component: changeAddress,
      meta: {
        title: '修改地址',
        type: ''
      }
    },
    {
      path: '/editAddr',
      name: 'editAddr',
      component: editAddr,
      meta: {
        title: '新建收貨地址',
        type: ''

      }
    },
    {
      path: '/map',
      name: 'map',
      component: map,
      meta: {
        title: '选择地址',
        type: ''
      }
    },
    {
      path: '/register',
      name: 'register',
      component: register,
      meta: {
        title: '註冊',
        type: ''
      }
    },
    {
      path: '/registerSupplyInfo',
      name: 'registerSupplyInfo',
      component: registerSupplyInfo,
      meta: {
        title: '賬號註冊',
        type: ''
      }
    },
    {
      path: '/policyPop',
      name: 'policyPop',
      component: policyPop,
      meta: {
        title: '用户协议',
        type: ''
      }
    },
    {
      path: '/cart',
      name: 'cart',
      component: cartIndex,
      meta: {
        title: 'SungivenPLUS',
        type: 'login'
      }
    },
    {
      path: '/orderIndex',
      name: 'orderIndex',
      component: orderIndex,
      meta: {
        title: '訂單中心',
        type: ''
      }
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: orderDetail,
      meta: {
        title: '訂單详情',
        type: ''
      }
    },
    {
      path: '/cancelOrder',
      name: 'cancelOrder',
      component: cancelOrder,
      meta: {
        title: '訂單取消',
        type: ''
      }
    },
    {
      path: '/orderRefund',
      name: 'orderRefund',
      component: orderRefund,
      meta: {
        title: '訂單售后',
        type: ''
      }
    }, {
      path: '/refundDetail',
      name: 'refundDetail',
      component: refundDetail,
      meta: {
        title: '退款进度',
        type: ''
      }
    },
    {
      path: '/account',
      name: 'account',
      component: account,
      meta: {
        title: '結算頁',
        type: ''
      }
    },
    {
      path: '/orderSuccess',
      name: 'orderSuccess',
      component: orderSuccess,
      meta: {
        title: '支付成功',
        type: ''
      }
    },
    {
      path: '/orderFail',
      name: 'orderFail',
      component: orderFail,
      meta: {
        title: '支付失敗',
        type: ''
      }
    },
    {
      path: '/orderStatus',
      name: 'orderStatus',
      component: orderStatus,
      meta: {
        title: '訂單狀態',
        type: ''
      }
    }, {
      path: '/payWaysList',
      name: 'payWaysList',
      component: payWaysList,
      meta: {
        title: '元初收銀台',
        type: ''
      }
    },
    {
      path: '/pcPay',
      name: 'pcPay',
      component: pcPay,
      meta: {
        title: 'PC扫码支付',
        type: 'login'
      }
    },
    {
      path: '/userCenterIndex',
      name: 'usercenterIndex',
      component: usercenterIndex,
      meta: {
        title: 'SungivenPLUS',
        type: 'login'
      }
    },
    {
      path: '/userInfoDetail',
      name: 'userInfoDetail',
      component: userInfoDetail,
      meta: {
        title: '會員信息',
        type: 'login'
      }
    },
    {
      path: '/set',
      name: 'set',
      component: set,
      meta: {
        title: '設置',
        type: ''
      }
    },
    {
      path: '/emailEdit',
      name: 'emailEdit',
      component: emailEdit,
      meta: {
        title: '郵箱設置',
        type: ''
      }
    },
    {
      path: '/emailEditSuccess',
      name: 'emailEditSuccess',
      component: emailEditSuccess,
      meta: {
        title: '郵箱設置',
        type: ''
      }
    },
    {
      path: '/emailValue',
      name: 'emailValue',
      component: emailValue,
      meta: {
        title: '郵箱設置',
        type: ''
      }
    },
    {
      path: '/cardManage',
      name: 'cardManage',
      component: cardManage,
      meta: {
        title: '信用卡管理',
        type: 'login'
      }
    },
    {
      path: '/vipCard',
      name: 'vipCard',
      component: vipCard,
      meta: {
        title: '元初卡',
        type: 'login'
      }
    },
    {
      path: '/consumeRecord',
      name: 'consumeRecord',
      component: consumeRecord,
      meta: {
        title: '消費記錄',
        type: 'login'
      }
    },
    {
      path: '/bindingCard',
      name: 'bindingCard',
      component: bindingCard,
      meta: {
        title: '绑定元初卡',
        type: 'login'
      }
    },
    {
      path: '/serviceGuide',
      name: 'serviceGuide',
      component: serviceGuide,
      meta: {
        title: '服务协议',
        type: ''
      }
    },
    {
      path: '/addCardSuccess',
      name: 'addCardSuccess',
      component: addCardSuccess,
      meta: {
        title: 'Sungiven+',
        type: 'login'
      }
    },
    {
      path: '/userCoupons',
      name: 'userCoupons',
      component: userCoupons,
      meta: {
        title: '我的优惠券',
        type: 'login'
      }
    }, {
      path: '/invalidCoupons',
      name: 'invalidCoupons',
      component: invalidCoupons,
      meta: {
        title: '失效优惠券',
        type: 'login'
      }
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      component: resetPassword,
      meta: {
        title: '忘記密碼',
        type: ''
      }
    },
    {
      path: '/productList',
      name: 'productList',
      component: productList,
      meta: {
        title: 'SungivenPLUS',
        type: 'login',
        keepAlive: true,
      }
    }, {
      path: '/goodsDetail',
      name: 'goodsDetail',
      component: goodsDetail,
      meta: {
        title: '商品详情'
      }
    }, {
      path: '/searchGoods',
      name: 'searchGoods',
      component: searchGoods,
      meta: {
        title: '搜索商品'
      }
    }, {
      path: '/specialColumn1',
      name: 'specialColumn1',
      component: specialColumn1,
      meta: {
        title: ''
      }
    }, {
      path: '/specialColumn2',
      name: 'specialColumn2',
      component: specialColumn2,
      meta: {
        title: ''
      }
    }, {
      path: '/specialColumn3',
      name: 'specialColumn3',
      component: specialColumn3,
      meta: {
        title: ''
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: logout,
      meta: {
        title: '申請註銷Sungiven+賬號',
        type: ''
      }
    },
    {
      path: '/sharePageDetail',
      name: 'sharePageDetail',
      component: sharePageDetail,
      meta: {
        title: 'Sungiven+',
        type: ''
      }
    }
  ]
})
var setDefaultStoreState = function() {
  store.state.curLocationAddr = "Vancouver City Hall";
  store.state.curCity = 'Vancouver';
  store.state.curLongitude = '-123.1162206';
  store.state.curLatitude = "49.2608202";
  store.state.postal_code = 'V5Y 1V4';
  store.state.locateCity = 'Vancouver';
  store.state.locateLongitude = '-123.1162206';
  store.state.locateLatitude = "49.2608202";
  store.state.locatePostalcode = 'V5Y 1V4';
  store.state.locateAddr = "Vancouver City Hall";
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js